import React from "react";
import { MessagesSquare } from "lucide-react";
import { useFloatingWindows } from "@/lib/floatingWindows";
import { useAuth } from "@/lib/auth";
import { canEditCard } from "@/lib/placement";

const SESSION_CARDS = ["cap_re_checkin", "cap_pillar_board", "cap_p1", "cap_p2", "cap_p3", "cap_p4"];

/** Opens the Sit-Down Session for one resident: conversation, every fix, then submit the weekly check-in. */
export function StartSessionButton({ residentId, name, className = "", onOpened }) {
  const { openWindow } = useFloatingWindows();
  const { user } = useAuth();
  if (!residentId || !SESSION_CARDS.some((c) => canEditCard(user, c))) return null;
  const open = (e) => {
    e.stopPropagation();
    e.preventDefault();
    openWindow("re_session", { title: name ? `Sit-Down Session · ${name}` : "Sit-Down Session", residentId, name });
    onOpened?.();
  };
  return (
    <span role="button" tabIndex={0} onClick={open} onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && open(e)} aria-label={`Start session with ${name || "resident"}`}
      data-testid={`start-session-${residentId}`}
      className={`inline-flex items-center gap-1 shrink-0 px-2 py-1 bg-nex-gold text-nex-ink rounded-sm font-mono text-[9px] tracking-[0.14em] uppercase cursor-pointer hover:bg-nex-goldbright transition-colors ${className}`}>
      <MessagesSquare className="h-3 w-3" /><span>Start session</span>
    </span>
  );
}
